module.exports = __webpack_public_path__ + "media/components/insights/safety-checks/icons/green-icon-95b1f386e22e7f3306621200c9954234.png";